export const timingFunctionMap = {
  'ease-out': (pos: number) => Math.sin(pos * (Math.PI / 2)),
  'ease-in-out': (pos: number) => -0.5 * (Math.cos(Math.PI * pos) - 1)
};

/**
 * Scroll to offset top of the element.
 *
 * @example
 *
 * scrollTo(document.querySelector('...'), 400, 'ease-in-out');
 */
export function scrollTo(
  element: HTMLElement,
  speed = 1000,
  timingFunction: keyof typeof timingFunctionMap = 'ease-out'
) {
  const scrollTargetY = element.offsetTop;
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  let currentTime = 0;
  // min time .1, max time .8 seconds
  const time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  );
  // add animation loop
  function step() {
    currentTime += 1 / 60;
    const p = currentTime / time;
    const t = timingFunctionMap[timingFunction](p);
    if (p < 1) {
      requestAnimationFrame(step);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  /**
   * called to start.
   */
  step();
}
